// extracted by mini-css-extract-plugin
module.exports = {"manaSymbol":"manaSymbol_manaSymbol__FzWB6","medium":"manaSymbol_medium__5plEB","small":"manaSymbol_small__SqwgE"};